/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
(function () {
  'use strict';

  angular.module('comcast.settings').controller('XferclientsController', ['$scope', '$state', '$stateParams', '$timeout', 'uiGridConstants', 'XferClientResourceFactory', 'loginService', function ($scope, $state, $stateParams, $timeout, uiGridConstants, XferClientResourceFactory, loginService) {
    /* PRIVATE : DATA */
    //Declare all private variables here

    /*
     * This is the `vm` object. It is a direct reference to the controller
     * which acts as our 'view-model' in angular. It also limits our need
     * to be accessing $scope directly. */

    /*jshint validthis:true*/
    var vm = this; // Store the search params in memory as we go

    var SearchParams = $stateParams;

    var _DynamicItems = function _DynamicItems() {
      this.reloadPages_();
    };

    _DynamicItems.prototype.getItemAtIndex = function (index, lazy) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber];
      lazy = lazy === undefined ? false : lazy;

      if (page) {
        return page[index % this.PAGE_SIZE];
      } else if (page !== null) {
        if (!lazy) {
          this.fetchPage_(pageNumber);
        }
      }
    };

    _DynamicItems.prototype.getLength = function () {
      return this.numItems;
    };

    _DynamicItems.prototype.setItemAtIndex = function (index, item) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber]; // Only update the screen if the spot is currently loaded

      if (page) {
        page[index % this.PAGE_SIZE] = item;
      }
    };

    _DynamicItems.prototype.fetchPage_ = function (pageNumber) {
      var self = this;
      vm.searching = true; // Set the page to null so we know it is already being fetched.

      self.loadedPages[pageNumber] = null;
      var pageOffset = pageNumber * self.PAGE_SIZE;
      var sortField = $stateParams.sortField ? $stateParams.sortField : 'xfer_client_id';
      var sortDirection = $stateParams.sortDirection ? $stateParams.sortDirection : 'DESC';
      $timeout(function () {
        // Filter out blank values, since we don't want to search by those
        for (var prop in SearchParams) {
          if (SearchParams.hasOwnProperty(prop)) {
            SearchParams[prop] = SearchParams[prop] === '' || SearchParams[prop] === null ? undefined : SearchParams[prop];
          }
        }

        SearchParams.offset = pageOffset;
        SearchParams.limit = self.PAGE_SIZE;
        SearchParams.sortField = sortField;
        SearchParams.sortDirection = sortDirection;
        SearchParams.accountId = vm.sessionData.accountId;
        XferClientResourceFactory.getAll(SearchParams, {}, function success(items) {
          items = items.data;
          self.loadedPages[pageNumber] = items.rows;
          self.numItems = items.count;
          vm.searching = false;
        }, function failure(err) {
          console.log(err);
        });
      });
    };

    _DynamicItems.prototype.reloadPages_ = function () {
      /**
       * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
       */
      this.loadedPages = {};
      /** @type {number} Total number of items. */

      this.numItems = 0;
      /** @const {number} Number of items to fetch per request. */

      this.PAGE_SIZE = 50;
      this.getItemAtIndex(0);
    };

    vm.sessionData = loginService.getSessionData();
    vm.dynamicItems = $stateParams.dynamicItems ? $stateParams.dynamicItems : new _DynamicItems();
    vm.sortObj = {
      field: $stateParams.sortField ? $stateParams.sortField : 'xfer_client_id',
      direction: $stateParams.sortDirection ? $stateParams.sortDirection : 'ASC'
    };
    vm.statusArray = [{
      status: 'offline',
      label: 'Offline'
    }, {
      status: 'online',
      label: 'Online'
    }, {
      status: 'notregistered',
      label: 'Not Registered'
    }, {
      status: 'noconfig',
      label: 'No Config'
    }];
    vm.bowser = bowser;
    /* BINDABLE : DATA */

    vm.openDetail = openDetail;
    vm.sort = sort;
    vm.labelStatus = labelStatus;
    /* BINDABLE : METHODS */

    function openDetail(row) {
      angular.element(document.querySelector('.sidebar')).addClass('invisible');
      $state.go('xferclientDetail', {
        id: row.id,
        dynamicItems: vm.dynamicItems
      }).then(function () {
        // Apply the animation ONLY when this transition happens
        $timeout(function () {
          angular.element(document.querySelector('.sidebar')).removeClass('invisible');
          angular.element(document.querySelector('.detail-list-area .side-grid')).addClass('slide-left-transition');
        }, 0);
      });
    }

    function sort(field) {
      if (vm.sortObj.field === field) {
        vm.sortObj.direction = vm.sortObj.direction === 'ASC' ? 'DESC' : 'ASC';
      } else {
        vm.sortObj.field = field;
        vm.sortObj.direction = 'ASC';
      }

      $state.go('xferclients', {
        sortField: vm.sortObj.field,
        sortDirection: vm.sortObj.direction
      }, {
        inherit: true
      });
    }

    function labelStatus(statusString) {
      for (var i = 0; i < vm.statusArray.length; i++) {
        if (vm.statusArray[i].status === statusString) {
          return vm.statusArray[i].label;
        }
      }

      return '';
    }
    /* EVENTS */
    //Register any event listeners

    /* INITIALIZATION */
    //Call controller initialization method here


    _init();
    /* IMPLEMENTATION : BINDABLE */

    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /**
     * Initialization for this controller.
     */


    function _init() {}
  }]);
})();